import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";

import api from "../../utils/api";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";

const FINANCIALS = "/financials";
const PERIODS = `${FINANCIALS}/periods`;
const CACHE_TIME = 30_600_000;

const getFinancialPeriods = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1] || {});
  return api.get(`${PERIODS}${queryString ? `?${queryString}` : ""}`);
};
export const useGetFinancialPeriods = ({ locationId, enabled = true } = {}) => {
  const params = locationId ? { location: locationId } : {};
  return useQuery([PERIODS, params], getFinancialPeriods, {
    enabled,
    staleTime: CACHE_TIME,
    cacheTime: CACHE_TIME,
  });
};

const getFinancialPeriodDetails = ({ queryKey }) =>
  api.get(`${PERIODS}/${queryKey[1]}`);
export const useGetFinancialPeriodDetails = (id) =>
  useQuery([PERIODS, id], getFinancialPeriodDetails, { enabled: !!id });

const postFinancialPeriod = (data) => api.post(PERIODS, data);
export const usePostFinancialPeriod = () => {
  const { addSnackbarSuccess, addSnackbarError } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postFinancialPeriod, {
    onSuccess: () => {
      invalidate(queryClient, PERIODS);
      addSnackbarSuccess({ message: "Financial period created" });
    },
    onError: (error) => addSnackbarError({ error }),
  });
};

const putFinancialPeriod = ({ id, ...data }) =>
  api.put(`${PERIODS}/${id}`, data);
export const usePutFinancialPeriod = () => {
  const { addSnackbarSuccess, addSnackbarError } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putFinancialPeriod, {
    onSuccess: () => {
      invalidate(queryClient, PERIODS);
      addSnackbarSuccess({ message: "Financial period updated" });
    },
    onError: (error) => addSnackbarError({ error }),
  });
};

const deleteFinancialPeriod = (id) => api.delete(`${PERIODS}/${id}`);
export const useDeleteFinancialPeriod = () => {
  const { addSnackbarSuccess, addSnackbarError } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(deleteFinancialPeriod, {
    onSuccess: () => {
      invalidate(queryClient, PERIODS);
      addSnackbarSuccess({ message: "Financial period deleted" });
    },
    onError: (error) => addSnackbarError({ error }),
  });
};
